import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from '../services/app-state.service';
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs/Subscription';
import { MatSidenav, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppError, AppInfo } from '../interfaces/app-error';
import { Observable } from 'rxjs/Observable';

@Component({
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.css'],  
})

export class PrivateComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  public userSubscription;
  public auth2: any;

  @ViewChild('sidebar') private sidenav: MatSidenav;
  public constructor(
    private appState: AppStateService,
    private authService: AuthService,
    private router: Router,
    public dialog: MatDialog) { }

  private sidebarStatus = null;

  public ngOnInit() {
    this.subscription = new Subscription();
    // this.subscription = this.sidenav.openedChange.subscribe((status) => {
    //   this.sidebarStatus = status;
    //   this.appState.toggleSideBar(status);
    // });

    this.appState.sidenav = this.sidenav;

    // const s = this.appState.sidebarStatusOpen$
    //   .subscribe(
    //   (newStatus) => {
    //     if (newStatus === this.sidebarStatus) {
    //       return;
    //     }
    //     if (!this.sidenav) {
    //       return;
    //     }
    //     if (newStatus) {
    //       this.sidenav.open();

    //     } else {
    //       this.sidenav.close();
    //     }
    //   }
    //   );
    // this.subscription.add(s);

    const es = this.appState.errorStatus$
      .filter((appError) => appError !== null)
      .subscribe((appError) => {
        this.openDialog(appError);
      });
    this.subscription.add(es);

    // Set appState function
    this.appState.confirmDialog = this.openConfirm;
    this.appState.infoDialog = this.openInfoDialog;

  }
  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public changeOfRoutes() {
    this.appState.toggleSideBar(false);
  }

  // Dialog for showing error messages
  openDialog(appError: AppError): void {
    console.log(appError);
    const dialogRef = this.dialog.open(AppErrorDialogComponent, {
      width: '250px',
      data: appError
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  // Dialog for showing info messages
  openInfoDialog = (appInfo: AppInfo): Promise<any> => {
    console.log(appInfo);
    const dialogRef = this.dialog.open(AppInfoDialogComponent, {
      width: '500px',
      data: appInfo
    });

    return dialogRef.afterClosed().toPromise();
  }

  // Dialog for showing error messages
  openConfirm  = (data: any): Promise<any> => {
    console.log(data);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data: data
    });

    return dialogRef.afterClosed().toPromise();
    // subscribe(result => {
    //   console.log('The confirm dialog was closed', result);
    // });
  }

}

@Component({
  selector: 'app-error-dialog',
  template: `<h1 mat-dialog-title>Error</h1>
  <div mat-dialog-content>
    <p>{{ data.errorMessage }}<p>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
  </div>`,
})
export class AppErrorDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AppErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'app-notify-dialog',
  template: `<h1 mat-dialog-title>Info</h1>
  <div mat-dialog-content>
    <p>{{ data.infoMessage }}<p>
    <p *ngIf="data.infoDetail">{{ data.infoDetail }}<p>
    <div class="html-preview" *ngIf="data.infoHtmlDetail" [innerHtml]="data.infoHtmlDetail"><div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
  </div>`,
  styles: [`
  .html-preview {
    font-size: smaller;
    font-style: italic;
    overflow-y: scroll;
    max-height: 300px;
}`]
})
export class AppInfoDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AppInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'app-confirm-dialog',
  template: `<h1 mat-dialog-title i18n>Please confirm, this action can not be reverted</h1>
  <div mat-dialog-content>
    <p>{{ data.confirmMessage }}<p>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial i18n>Cancel</button>
    <button mat-button color="accent" (click)="confirm()" i18n>OK</button>
  </div>`,
})
export class ConfirmDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close({ confirm: true });
  }

}



// WEBPACK FOOTER //
// ./src/app/private/private.component.ts